export const BOATS_PER_PAGE = 12;

export const DAYTIME_FORMAT = 'YYYY-MM-DDTHH:mm:ss.sssZ';
export const DAY_FORMAT = 'YYYY-MM-DD';
export const MONTH_FORMAT = 'YYYY-MM';

export const DAYTIME_INPUT_FORMAT = 'YYYY-MM-DDTHH:mm'; // for input type datetime-local
